<template>
  <div>
  <div class="content content-boxed">

      <div class="col-sm-12">
          <div class="block">
              <div class="block-header">

                  <h3 v-if="invitation.SharedEntityType=='Channel'" class="block-title"><i class="fa fa-share-alt fa-2x"></i> {{titleSharingChannel[actualLanguage]}}</h3>
                  <h3 v-if="invitation.SharedEntityType=='Device'" class="block-title"><i class="fa fa-share-alt fa-2x"></i> {{titleSharingDevice[actualLanguage]}}</h3>
                  <h3 v-if="invitation.SharedEntityType=='Bundle'" class="block-title"><i class="fa fa-share-alt fa-2x"></i> {{titleSharingBundle[actualLanguage]}}</h3>
                  <h3 v-if="invitation.SharedEntityType=='Group'" class="block-title"><i class="fa fa-share-alt fa-2x"></i> {{titleSharingGroup[actualLanguage]}}</h3>
              </div>

              <div class="block-content">
<!--                
<h4>Parent : {{parentContainer}}</h4>              
<h4>Group : {{actualGroup.group_id}}</h4> 
<h4>Bundle : {{actualBundle.bundle_id}}</h4>
-->


                <div  class="col-xs-12 push">
                  <div class="col-xs-12 col-sm-3 align-center">
                      <i v-if="invitation.SharedEntityType=='Channel'" class="fa fa-television fa-3x"></i>
                      <i v-if="invitation.SharedEntityType=='Device'" class="fa fa-server fa-3x"></i>
                      <i v-if="invitation.SharedEntityType=='Bundle'" class="fa fa-usb fa-3x"></i>
                      <i v-if="invitation.SharedEntityType=='Group'" class="fa fa-group fa-3x"></i>
                      <i v-if="invitation.SharedEntityType=='Car'" class="fa fa-car fa-3x"></i>
                  </div>

                  <div class="col-xs-12 col-sm-9">
                      <h4 class="block-title">Invitation de : {{invitation.HostEmail}}</h4>
                      <h5>{{invitation.SharingInfo.referenceName}}</h5>
                      <p>{{invitation.SharingInfo.sharingMessage}}</p>

                      <div v-if="invitation.SharedEntityType=='Bundle'" class="col-xs-12 col-sm-12">
                        <p v-if="actualBundle.bundle_id == '!!NONE!!'">{{messageBundleReceptionRacine[actualLanguage]}}</p>
                        <p v-if="actualBundle.bundle_id != '!!NONE!!'">{{messageBundleReception[actualLanguage]}}</p>
                        <label v-if="actualBundle.bundle_id != '!!NONE!!'"  class="css-input switch switch-success">
                            <input type="checkbox" checked v-model="flagSaveBundleAtSameLevel">
                            <span></span> {{labelCheckBoxBundle[actualLanguage]}}
                        </label>
                      </div>

                      <div v-if="invitation.SharedEntityType=='Group'" class="col-xs-12 col-sm-12">
                        <p v-if="actualGroup.group_id == '!!NONE!!'">{{messageGroupReceptionRacine[actualLanguage]}}</p>
                        <p v-if="actualGroup.group_id != '!!NONE!!'">{{messageGroupReception[actualLanguage]}}</p>
                        <label  class="css-input switch switch-success">
                            <input type="checkbox" checked v-model="flagSaveGroupAtFirstLevel">
                            <span></span> {{labelCheckBoxGroup[actualLanguage]}}
                        </label>
                      </div>

                  </div>
                </div>


                <div  class="col-xs-12 align-center push">
                    <div v-if="invitation.SharedEntityType=='Group'" class="col-xs-12 col-sm-6">

                      <div v-if="defaultGroupSelectedFlag & flagSaveGroupAtFirstLevel==false" class="col-xs-12 col-sm-12">
                        <p>{{mustSelectGroupNotDefaultGroup[actualLanguage]}}</p>
                      </div>
                      <div v-else class="col-xs-12 col-sm-12">
                        <button @click="acceptSharing(index)" class="btn btn-xs btn-success push" type="button" data-toggle="tooltip" title="Accept"><i class="fa fa-check"></i> {{labelButtonAccept[actualLanguage]}}</button>
                      </div>                  
                      
                    </div>

                    <div v-if="invitation.SharedEntityType=='Bundle'" class="col-xs-12 col-sm-6">
                      <div v-if="defaultGroupSelectedFlag" class="col-xs-12 col-sm-12">
                        <p>{{mustSelectGroupNotDefaultBundle[actualLanguage]}}</p>
                      </div>
                      <div v-else class="col-xs-12 col-sm-12">
                        <button @click="acceptSharing(index)" class="btn btn-xs btn-success push" type="button" data-toggle="tooltip" title="Accept"><i class="fa fa-check"></i> {{labelButtonAccept[actualLanguage]}}</button>
                      </div>  
                    </div>

                    <div v-if="invitation.SharedEntityType=='Device'" class="col-xs-12 col-sm-6">
                      <button @click="acceptSharing(index)" class="btn btn-xs btn-success push" type="button" data-toggle="tooltip" title="Accept"><i class="fa fa-check"></i> {{labelButtonAccept[actualLanguage]}}</button>
                    </div>

                    <div v-if="invitation.SharedEntityType=='Channel'" class="col-xs-12 col-sm-6">
                      <button @click="acceptSharing(index)" class="btn btn-xs btn-success push" type="button" data-toggle="tooltip" title="Accept"><i class="fa fa-check"></i> {{labelButtonAccept[actualLanguage]}}</button>
                    </div>

                    <div v-if="invitation.SharedEntityType=='Car'" class="col-xs-12 col-sm-6">
                      <button @click="acceptSharing(index)" class="btn btn-xs btn-success push" type="button" data-toggle="tooltip" title="Accept"><i class="fa fa-check"></i> {{labelButtonAccept[actualLanguage]}}</button>
                    </div>

                    <div  class="col-xs-12 col-sm-6">
                      <button @click="rejectSharing(index)" class="btn btn-xs btn-danger push" type="button" data-toggle="tooltip" title="Reject"><i class="fa fa-times"></i> {{labelButtonReject[actualLanguage]}}</button>
                    </div>
                </div>

                <p>{{sharingBottomMessage[actualLanguage]}}</p>

              </div>

          </div>
      </div>
                       

  </div>
</div>

</template>


<script>

import Spinner from '@/components/Spinner'
import _ from 'underscore'
import {mapState, mapActions, mapGetters} from 'vuex'


export default {
  name: 'SharingItem',
  props: ['index'],

  data() {
    return {
      isOpen : true,
      dataTempo01 : 'test',
      dataTempo02 : 'test',
      loadingData : false,
      defaultGroupSelectedFlag : false,
      invitation : {},

      messageNoMoreSharing: {FR: "Plus de partage en attente pour l'instant. Vous devez selectionner un autre menu.", EN: 'No more sharings for now. Select other menu.'},

      titleSharingChannel: {FR: "Partage d'appareil", EN: 'Device sharing'},
      titleSharingDevice: {FR: "Partage de module de mesure", EN: 'Monitoring module'},
      titleSharingBundle: {FR: 'Partage de système', EN: 'System sharing'},
      titleSharingGroup: {FR: 'Partage de groupe', EN: 'Group sharing'},

      labelButtonAccept: {FR: 'Accepter le partage', EN: 'Accept sharing'},
      labelButtonReject: {FR: 'Refuser le partage', EN: 'Reject sharing'},
      sharingBottomMessage: {FR: "L'acceptation ou le refus du partage doit s'effectuer au maximum 30 jours aprés son émission.", EN: 'Acceptation or Rejection of sharing must be done within the next 30 days of its emission.'},
      mustSelectGroupNotDefaultGroup : {FR: "Vous devez obligatoirement sélectionner l'option Groupe de premier niveau", EN: 'You must select the option First Level Group'},
      mustSelectGroupNotDefaultBundle : {FR: "Vous devez sélectionner un groupe usager et un groupe système autre que votre profile pour accepter le partage.",  EN: 'You must select a User Groupe and System Groupe to accept the sharing.'},

      messageGroupReceptionRacine: {FR: "L'acceptation du groupe sera enregistré comme groupe racine a votre profile. Si vous désirez enregistrer ce groupe comme sous groupe d'un groupe existant, vous devez sélectionner le groupe dans lequel vous désirez enregistrer AVANT d'accepter le partage.", EN: 'Group is by default save as first level group in your profile. It is possible to save the group as sub group selecting the recipient groupe BEFORE accepting the sharing.'},
      messageGroupReception: {FR: "L'enregistrement d'un groupe s'enregistre comme Sous Groupe du groupe actuellement séléctionné. Il est possible d'enregistrer un Groupe comme groupe de premier niveau dans votre profil en utilisant l'option suivante:", EN: 'User group is by default save as a sub Group in the actual selected Group, it is possible to save the group as first level group in your profile by using the following option:'},
      labelCheckBoxGroup: {FR: 'Enregistrer ce groupe en tant que groupe de premier niveau', EN: 'Save this group as first level group'},
      flagSaveGroupAtFirstLevel : false,

      messageBundleReception: {FR: "L'enregistrement d'un Système s'enregistre comme Sous Système du Système actuellement séléctionné. Il est possible d'enregistrer le Système comme Système de même niveau que le Système actuellement sélectionné en utilisant l'option suivante:", EN: 'System is by default save as a Sub System in the actual selected System, it is possible to save the System at same level as the actual System by using the following option:'},
      messageBundleReceptionRacine: {FR: "L'acceptation du partage du Système sera enregistré dans le groupe actuellement sélectionné. Si vous désirez enregistrer ce partage dans un Système, vous devez sélectionner ce système AVANT d'accepter le partage", EN: 'System is by default save as a System in the actual selected Group, it is possible to save the System into another system by selecting the System BEFORE sharing acceptation'},

      labelCheckBoxBundle: {FR: 'Enregistrer ce Système au même niveau', EN: 'Save this System at same level'},
      flagSaveBundleAtSameLevel : false,
      
      actualLanguage : "FR",

    }
  },
  components: {
    Spinner,

  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','planTransactionData','actualGroup','actualBundle','parentContainer']),
    ...mapState('devicesStore',['devices', 'devicesPortData']),
  },

  watch: {
    actualGroup(){
      this.defaultGroupSelectedFlag =  this.actualGroup.group_id.includes(':DefaultGroup')
    }
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),



    reloadPage(){
      window.location.reload()
    },
 

    acceptSharing(sharingIndex){
      //Ajouter des conditions de sélection de groupe de premier niveau OU sous le groupe de premier niveau sélectionné
      //Ajouter une case a cocher
      var confirmAcceptSharing = false
      if (this.actualLanguage == "FR"){
        if (window.confirm(`Confirmer de l'acceptation du partage. L'aceptation de partage agit sur le compteur d'appareils de votre organisation.`)){
            confirmAcceptSharing = true
        }
        }else{
        if (window.confirm(`Confirm the sharing acceptance. Sharing acceptance increase your organization devices counter.`)){
            confirmAcceptSharing = true            
          }
        }



      if(confirmAcceptSharing){
            var requestData = { 'postAction':'AcceptSharing',
                                'invitationId':this.profileData.sharingInvitations[sharingIndex].InvitationId,
                                'parentContainer':this.parentContainer,
                                'groupId':this.actualGroup.group_id,
                                'bundleId':this.actualBundle.bundle_id,
                                'flagSaveGroupFirstLevel':this.flagSaveGroupAtFirstLevel,
                                'flagSaveBundleAtSameLevel':this.flagSaveBundleAtSameLevel,
                                }

            this.$store.dispatch('sessionStore/postRule', requestData)
                .then((response) => {
                //console.log('Reponse acceptation sharing') 
                //console.log(response.data)          
                if(response.data.Code=='OK'){
                    
                    window.alert(response.data.PromptMessage[this.actualLanguage])
                    //this.profileData.sharingInvitations[sharingIndex].InvitationStatus='Accepted'
                      this.$store.dispatch('sessionStore/refreshProfileData')
                      .then((response) => {
                          this.$store.dispatch('sessionStore/getGroupArborescence')
                          .then((response) => {
                            this.flagBundleIsLoading = false
                          })
                      })
                    }
                    else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
                })
      }

    },


    rejectSharing(sharingIndex){
      var confirmRejectSharing = false
      if (this.actualLanguage == "FR"){
        if (window.confirm(`Confirmer le refus du partage`)){
            confirmRejectSharing = true
        }
        }else{
        if (window.confirm(`Confirm the sharing reject`)){
            confirmRejectSharing = true            
          }
        }

      if(confirmRejectSharing){
            var requestData = { 'postAction':'RejectSharing',
                                'invitationId':this.profileData.sharingInvitations[sharingIndex].InvitationId,
                                'groupId':this.actualGroup.group_id,
                                'bundleId':this.actualBundle.bundle_id,
                                'flagSaveGroupFirstLevel':this.flagSaveGroupAtFirstLevel,
                                'flagSaveBundleAtSameLevel':this.flagSaveBundleAtSameLevel,
                                }

            this.$store.dispatch('sessionStore/postRule', requestData)
                .then((response) => {
                  //console.log('-----TEST BUTTON------')
                  //console.log(response.data)
                if(response.data.Code=='OK'){
                    window.alert(response.data.Message[this.actualLanguage])
                    //this.profileData.sharingInvitations[sharingIndex].InvitationStatus='Rejected'
                    this.$store.dispatch('sessionStore/refreshProfileData')
                    }
                    else{ window.alert("L'enregistrement a échoué. / Saving fail." )}
                })
      }

    },


    refreshBundle(){
        var requestData = {'postAction':'ReadBundleData','bundleId':this.bundleTempo.bundle_id}
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                //console.log('-Accept sharing refresh bundle-')
                //console.log(response.data.BundleData)
                this.bundleTempo = response.data.BundleData
                this.$store.dispatch('sessionStore/setActualBundle', this.bundleTempo)
                this.flagBundleSelected = true
                }
                else{window.alert("La lecture a échouée. / Reading fail." )}
            })      
    }



    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()
    window.scrollTo(0, 0)
    this.defaultGroupSelectedFlag =  this.actualGroup.group_id.includes(':DefaultGroup')

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  },

  beforeMount(){
    this.invitation = this.profileData.sharingInvitations[this.index]
  }
}
</script>




// WEBPACK FOOTER //
// SharingItem.vue?46a71175